import * as THREE from "three";

/**
 * 씬에 기본 라이트 세팅(헤미+디렉셔널)
 * - castShadows가 true면 그림자 설정까지 포함
 * - 반환값으로 라이트 핸들을 돌려줘서 이후 intensity/position 조정 가능
 */
export function setupLights(
  scene,
  {
    dirIntensity = 3, // 태양광 밝기
    hemiSky = 0xffffff, // 상단 색상
    hemiGround = 0x202020, // 하단 색상
    hemiIntensity = 5.0, //밝기
    castShadows = true, // 그림자 사용 여부
    shadowMapSize = 2048, // 그림자 텍스처 해상도
    shadowRange = 10, // 직교 그림자 카메라 범위
  } = {}
) {
  const hemi = new THREE.HemisphereLight(hemiSky, hemiGround, hemiIntensity);
  scene.add(hemi);

  const dir = new THREE.DirectionalLight(0xffffff, dirIntensity);
  dir.position.set(0, 0, 1);
  if (castShadows) {
    dir.castShadow = true;
    dir.shadow.mapSize.set(shadowMapSize, shadowMapSize);
    // 직교 그림자 카메라 범위 설정(누수/깜빡임 줄이기)
    const cam = dir.shadow.camera;
    cam.near = 0.1;
    cam.far = 50;
    cam.left = -shadowRange;
    cam.right = shadowRange;
    cam.top = shadowRange;
    cam.bottom = -shadowRange;
  }
  scene.add(dir);

  return { hemi, dir };
}
